import { render } from "./PriceBuySellCard.vue?vue&type=template&id=274a29a5"
import script from "./PriceBuySellCard.vue?vue&type=script&lang=js"
export * from "./PriceBuySellCard.vue?vue&type=script&lang=js"
script.render = render

export default script